import { render, staticRenderFns } from "./DotBlueIcon.vue?vue&type=template&id=451ddd32&scoped=true&"
var script = {}
import style0 from "./DotBlueIcon.vue?vue&type=style&index=0&id=451ddd32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ddd32",
  null
  
)

export default component.exports